/* eslint-disable @typescript-eslint/no-explicit-any */
import { Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

//Font-end
import { PageNotFound } from "./pages/404Page";
import { PageLayout } from "./components/PageLayout";
import { TimeInOutInfo } from "./pages/font-end/TimeInOutInfo";
import { SalaryRequest } from "./pages/font-end/SalaryRequest";
import { Home } from "./pages/font-end/Home";
import { Anouncement } from "./pages/font-end/Anouncement";
import { AnouncementDetail } from "./pages/font-end/AnouncementDetail";

//Check Time Login
import IdleTimeOutHandler from "./components/IdleTimeOutHandler";

//Backoffice

import { Dashboard } from "./pages/backend/Dashboard";
import { SuperAdmin } from "./pages/backend/SuperAdmin";
import PermissionGroupMenu from "./pages/backend/PermissionGroupMenu";
import { Schedulers } from "./pages/backend/Schedulers";
import { Salary } from "./pages/backend/Salary";
import { Annoucement } from "./pages/backend/Annoucement";
import { Payroll } from "./pages/backend/Payroll";
import { Authen } from "./pages/backend/Authen";
import Protected from "./Protected";
import {
  getUserSalaryGroup,
  getUserSupperAdminHrmibleGroup,

} from "./services/PermissionGroup";
import { UseDesktop } from "./pages/backend/useDesktop";
import { Service } from "./pages/font-end/Service";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

// TODO: Consider refactoring App.tsx to use UserContext instead in a future update
import { getInfoUsers } from "./services/ApiGetUserInfo";

import withClearCache from "./ClearCache";
import { UserProvider } from './context/UserContext';
import { ConsentModal } from './modal/frontend/ConsentModal';
import { GetUserConsent } from './services/ApiConsent';
import { GetActivePurposes } from './services/ApiConsent';

const Pages = (props: any) => {
  const [infoUsers, setInfoUsers] = useState(true);
  const [showConsentModal, setShowConsentModal] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        localStorage.setItem("Language", "th");
        // display modal if user has never given consent or version of consent is updated
        const adminUris = ["backoffice", "superadmin"];

        const isAdminPanel = adminUris.some((uri) =>
          window.location.pathname.includes(`/${uri}`)
        );
        
        // Temporarily always show consent modal for testing
        // setShowConsentModal(true);


        //console.info("isAdminPanel", isAdminPanel);

        if (isAdminPanel) return;
        const infoUser = await getInfoUsers();
        const checkPath = window.location.pathname.includes("service");
        if (infoUser?.codComp1 === "PST" && !checkPath) {
          setInfoUsers(false);
          return (window.location.href = window.location.origin + "/service");
        }

        // Check user consent status
        const userPurposesAgreement = await GetUserConsent({
          idOrEmail: infoUser?.email,
        });
        const activePurposesRes = (await GetActivePurposes()) || [];
        const userPurposes = userPurposesAgreement?.content[0]?.Purposes || [];

        const matchedPurposes = [];
        let hasNewVersion = false;

        // Check for matching purposes
        for (const apr of activePurposesRes) {
          const matchedPurpose = userPurposes?.find(
            (up: any) => apr?.purposeId === up?.Id
          );
          matchedPurpose && matchedPurposes.push(matchedPurpose);
        }

        // Check for version changes
        for (const apr of activePurposesRes) {
          hasNewVersion = userPurposes?.some(
            (up: any) =>
              apr?.purposeId === up?.Id && apr?.version !== up?.Version
          );
          if (hasNewVersion) {
            break;
          }
        }

        // Check if there are any new purposes
        const hasNewPurpose =
          activePurposesRes?.length !== matchedPurposes?.length ? true : false;

        // Show consent modal if needed
        if (!userPurposes?.length || hasNewPurpose || hasNewVersion) {
          setShowConsentModal(true);
        }

      } catch (error) {
        console.log(error);
      }
    })();
  }, [infoUsers]);

  return (
    <>
      <ConsentModal 
        showModal={showConsentModal}
        hideModal={() => setShowConsentModal(false)}
      />

      {!infoUsers && (
        <>
          <Routes>
            <Route path="/service" element={<Service />} />
          </Routes>
        </>
      )}

      {infoUsers && (
        <>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/time_in_out/:id" element={<TimeInOutInfo />} />
            <Route path="/salary" element={<SalaryRequest />} />
            <Route path="/anouncement" element={<Anouncement />} />
            <Route path="/service" element={<Service />} />
            <Route path="/anouncement/:id" element={<AnouncementDetail />} />
            
            {/* Redirect routes for admin panels without trailing slash */}
            <Route path="/superadmin" element={<Navigate to="/superadmin/" replace />} />
            <Route path="/backoffice" element={<Navigate to="/backoffice/" replace />} />
            
            <Route
              path="/superadmin/"
              element={
                <Protected isAdmin={props.isAdmin} role="superadmin" isCheckingPermission={props.isCheckingPermission}>
                  <SuperAdmin />
                </Protected>
              }
            />
            <Route
              path="/superadmin/PermissionGroupMenu"
              element={
                <Protected isAdmin={props.isAdmin} role="superadmin" isCheckingPermission={props.isCheckingPermission}>
                  <PermissionGroupMenu />
                </Protected>
              }
            />
            <Route
              path="/backoffice/"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Dashboard />
                </Protected>
              }
            />
            <Route
              path="/backoffice/schedulers"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Schedulers />
                </Protected>
              }
            />
            <Route
              path="/backoffice/Salary"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Salary />
                </Protected>
              }
            />
            <Route
              path="/backoffice/anouncement"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Annoucement />
                </Protected>
              }
            />
            <Route
              path="/backoffice/payroll"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <Payroll />
                </Protected>
              }
            />
            <Route
              path="/desktop-olny"
              element={
                <Protected isAdmin={props.isAdmin} role="backoffice" isCheckingPermission={props.isCheckingPermission}>
                  <UseDesktop />
                </Protected>
              }
            />
      
            <Route path="*" element={<PageNotFound />} />
            <Route path="/auth/:role" element={<Authen />} />
          </Routes>
        </>
      )}
    </>
  );
};
const Login = () => {
  const { instance } = useMsal();
  localStorage.clear();
  instance.loginRedirect(loginRequest).catch((e) => {
    //console.log('login xxxx=>', e)
  });
  return (
    <>
      <div className="layout-loading">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

const App = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isLogout, setLogout] = useState(false);
  const [isCheckingPermission, setIsCheckingPermission] = useState(true);
  const hostname: string = window.location.pathname;

  // เรียก getUserSalaryGroup ครั้งแรกหลัง login (หรือ mount)
  useEffect(() => {
    getUserSalaryGroup().then(() => {
      // ไม่ต้อง setIsAdmin ที่นี่ ให้ logic เดิมจัดการต่อ
    });
  }, []);

  // Use an effect for permission check to avoid multiple unnecessary checks
  useEffect(() => {
    let isMounted = true;
    
    const checkPermission = async () => {
      try {
        // รอให้ usergroup โหลดเสร็จก่อน (สำหรับกรณี bookmark)
        let userGroup = sessionStorage.getItem('usergroup');
        let attempts = 0;
        const maxAttempts = 20; // รอสูงสุด 10 วินาที
        
        while (!userGroup && attempts < maxAttempts && isMounted) {
          await new Promise(resolve => setTimeout(resolve, 500));
          userGroup = sessionStorage.getItem('usergroup');
          attempts++;
        }
        
        if (!isMounted) return;
        
        // ถ้าไม่มี usergroup หลังจากรอแล้ว แสดงว่าต้อง login
        if (!userGroup) {
          setIsCheckingPermission(false);
          setIsAdmin(false);
          return;
        }
        
        // Cache permission check results to avoid redundant calls
        const permissionCacheKey = `permission_cache_${hostname}`;
        const cachedPermission = sessionStorage.getItem(permissionCacheKey);
        
        if (cachedPermission !== null && isMounted) {
          setIsAdmin(cachedPermission === 'true');
          setIsCheckingPermission(false);
          return;
        }
        
        let permission = false;
        
        if (hostname.includes("backoffice")) {
          permission = await getUserSalaryGroup();
        } else if (hostname.includes("superadmin")) {
          permission = await getUserSupperAdminHrmibleGroup();
        } else {
          permission = await getUserSalaryGroup();
        }
        
        if (!isMounted) return;
        
        // Cache the permission result
        sessionStorage.setItem(permissionCacheKey, permission ? 'true' : 'false');
        
        setIsAdmin(permission);
        setIsCheckingPermission(false);
      } catch (error) {
        console.error("Error checking permissions:", error);
        if (isMounted) {
          setIsAdmin(false);
          setIsCheckingPermission(false);
        }
      }
    };
    
    checkPermission();
    
    return () => {
      isMounted = false;
    };
  }, [hostname]);

  if (process.env.REACT_APP_ENV == "test") {
    return (
      <>
        <PageLayout>
          <Pages isAdmin={isAdmin} isCheckingPermission={isCheckingPermission} />
        </PageLayout>
      </>
    );
  }

  return (
    <>
      <AuthenticatedTemplate>
        <PageLayout>
          <IdleTimeOutHandler
            onActive={() => {
              setIsActive(true);
            }}
            onIdle={() => {
              setIsActive(false);
            }}
            onLogout={() => {
              setLogout(true);
            }}
            timeOutInterval={process.env.REACT_APP_TIMEOUT_LOGIN} //10 minute
          />
          <Pages isAdmin={isAdmin} isCheckingPermission={isCheckingPermission} />
        </PageLayout>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

const ClearCacheComponent = withClearCache(App);

const AppWithUserProvider = () => (
  <UserProvider>
    <App />
  </UserProvider>
);

export default AppWithUserProvider;
